/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Type_StandardInputs */

const en_customer_type_standard = /** @type {(inputs: Customer_Type_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard`)
};

const es_customer_type_standard = /** @type {(inputs: Customer_Type_StandardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estandar`)
};

/**
* | output |
* | --- |
* | "Standard" |
*
* @param {Customer_Type_StandardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const customer_type_standard = /** @type {((inputs?: Customer_Type_StandardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Type_StandardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_customer_type_standard(inputs)
	return es_customer_type_standard(inputs)
});